import { render, staticRenderFns } from "./sale-order.vue?vue&type=template&id=1301f6ab&"
import script from "./sale-order.vue?vue&type=script&lang=ts&"
export * from "./sale-order.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports